import { DataGridPremium, type GridApi } from '@mui/x-data-grid-premium'
import { memo, useMemo, useRef } from 'react'
import { useCardTokens } from '../../api/react-query'
import { type CardTokenRow, TOKEN_COLUMNS } from './CardTokensHelper'

interface CustomerCardTabOverviewSingleCardDetailsTokensProps {
  customerId: string
  cardId: string
}

export const CustomerCardTabOverviewSingleCardDetailsTokens = memo(function CustomerCardTabOverviewSingleCardDetailsTokens({
  customerId,
  cardId,
}: CustomerCardTabOverviewSingleCardDetailsTokensProps) {
  const apiRef = useRef<GridApi>({} as GridApi)

  const { data: tokenData } = useCardTokens(customerId, cardId)

  const mappedData = useMemo<CardTokenRow[]>(() => {
    if (!tokenData) return []

    return tokenData.map((token, index) => ({
      id: `${token.walletProvider}-${index}`,
      walletProvider: token.walletProvider,
      status: token.status,
      walletProviderName: token.walletProviderName,
      deviceName: token.deviceInfo?.deviceName,
      deviceType: token.deviceInfo?.deviceType,
      mobileNumberLast4: token.deviceInfo?.mobileNumberLast4,
    }))
  }, [tokenData])

  return (
    <DataGridPremium
      apiRef={apiRef}
      rows={mappedData}
      columns={TOKEN_COLUMNS}
      getRowHeight={() => 'auto'}
      headerFilters
      disableColumnFilter
      headerFilterHeight={81}
      pagination
      disableRowSelectionOnClick
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
        sorting: { sortModel: [{ field: 'status', sort: 'asc' }] },
        filter: { filterModel: { items: [] } },
      }}
      pageSizeOptions={[10, 25, 50]}
      slotProps={{ toolbar: { showQuickFilter: true }, headerFilterCell: { showClearIcon: true } }}
    />
  )
})
